module.exports = __webpack_public_path__ + "static/media/downloadAndroid.f2d380b5.png";